<template>
  <div style="padding-top: 40px; padding-left: 0px;">
    <div id="QRA">
      <img src="../../../static/scan.gif" width="400">
      <hr>
      <h1 style="color: #000">Scan QR CODE สำหรับ ทางเข้า</h1>
      <hr>
      <button type="button" class="btn btn-info btn-lg" style="font-size: 40px;" @click="inputPassword">
        <b v-if="$store.state.lang == 0">Use Password</b>
        <b v-if="$store.state.lang == 1">ใช้แบบกรอกรหัส</b>
        <b v-if="$store.state.lang == 2">輸入密碼</b>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import $ from "jquery";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";
import api from "../../service/services";
export default {
  data() {
    return {
      step_process: "",
      Time: 0,
      response: "",
      member_id: "",
      member_code: "",
      rfid_code: "",
      qr_code: "",
      pin_code: "",
      member_name_th: "",
      member_last_name_th: "",
      balance: "",
      qr_code_test: "83"
    };
  },
  computed: {
    ...mapState([
      "lang",
      "UUID",
      "accessToken",
      "Mode",
      "Type",
      "AmountPayment",
      "AuthenType",
      "isconnect_emitterpay",
      "StatusQrcode",
      "customerBalance"
    ]),
    ...mapMutations(["onMessageWs"])
  },
  methods: {
    // websocket_onmessage() {
    //   this.$socket.onmessage = skResult => {
    //     this.$store.commit("openGate", JSON.parse(skResult.data));
    //   };
    // },
    inputPassword() {
      this.Soundclick();
      this.$store.state.AuthenType = 4;
    },
    openDoor() {
      this.$store.state.isLoading = true;
      const header = {
        headers: {
          "x-access-token": this.accessToken
        }
      };
      var body = { code: this.$store.state.StatusQrcode };
      api.checkBalance(
        body,
        header,
        result => {
          this.$store.state.StatusQrcode = null;
          this.$store.state.customerBalance = result;
          if (result.response === "valid") {
            Swal.fire({
              title: "แจ้งเตือน !",
              html:
                "<h2 style='color: #555;'> " +
                this.customerBalance.member_name_th +
                "&nbsp;&nbsp;" +
                this.customerBalance.member_last_name_th +
                " มียอดเงินคงเหลือ " +
                result.balance +
                " บาท </h2> <h2>ต้องการใช้สิทธิในการเปิดประตูใช่หรือไม่ ?</h2>",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes"
            }).then(result => {
              if (result.value) {
                this.$socket.sendObj({
                  command: "open_cash_box",
                  data: 10
                });
              }
            });
          } else {
            $("#Modal").modal("hide");
            this.SoundFaild();
            Swal.fire({
              title: "แจ้งเตือน ?",
              html:
                "<h3 style='color: #555;'>หมายเลขของท่าน ยังไม่ได้รับการลงทะเบียน กรุณาติดต่อเจ้าหน้าที่</h3>",
              type: "error"
            });
          }
          this.$store.state.isLoading = false;
        },
        error => {
          $("#Modal").modal("hide");
          Swal.fire({
            title: "แจ้งเตือน ?",
            html: "<h2 style='color: #555;'>หมายเลขของท่าน ยังไม่ได้รับการลงทะเบียน กรุณาติดต่อเจ้าหน้าที่</h2>",
            type: "error"
          });
          this.$store.state.isLoading = false;
          alert(JSON.stringify(error));
        }
      );
    }
  },
  mounted() {
    this.step_process = setInterval(() => {
      if (this.$store.state.StatusQrcode) {
        this.openDoor();
        clearInterval(this.step_process);
      }
    }, 1000);
    // setTimeout(() => {
    //   this.$store.state.StatusQrcode = "+660946358888";
    // }, 5000);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal/gate.vue